import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30db1714"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMousedown"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggable-portion draggable-portion-left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggable-portion draggable-portion-right" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggable-portion draggable-portion-top" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggable-portion draggable-portion-bottom" }, null, -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

import {onMounted, onUnmounted, PropType, ref, Ref} from "vue";
import {onElementResize} from "@/lib/common/utilities/DomUtilities";
import {Draggable} from "@/lib/common/interfaces/gsap";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'DraggableResizableElement',
  props: {
  startLeftPosition: {
    type: Number,
    required: true,
  },
  startTopPosition: {
    type: Number,
    required: true,
  },
  startWidth: {
    type: Number,
    required: true,
  },
  startHeight: {
    type: Number,
    required: true,
  },
  zIndex: {
    type: String,
    required: true
  },
  parentContainerRef: {
    type: Object as PropType<Ref<HTMLElement>>,
    required: true,
  },
  className: String,
  isDraggable: Boolean,
  isDraggableOnlyFromBorders: Boolean,
  isResizable: Boolean,
  isDisabled: Boolean,
},
  emits: ["onClick", "onClickInTheMiddle", "onDragResizeStart", "onDragResizeEnd"],
  setup(__props, { expose, emit: emits }) {

const props = __props

_useCssVars(_ctx => ({
  "dde8986e": (_ctx.leftPx),
  "2e6d87a3": (_ctx.topPx),
  "b12f385c": (__props.zIndex),
  "45f24b58": (_ctx.widthPx),
  "3c49232e": (_ctx.heightPx)
}))


/**
 * A component that makes its content Draggable and Resizable.
 * Works on absolute and fixed positioning. Does not work with transforms.
 * Pass it its container to make it unable to leave it.
 */





// ------------------------------
//  Drag & Resize
// ------------------------------

const drElement = ref();
const drElementInside = ref();
const bottomRightResizer = ref();
const bottomLeftResizer = ref();
const topRightResizer = ref();
const topLeftResizer = ref();
const draggablePortionsContainer = ref();

onMounted(() =>
{
  onElementResize(props.parentContainerRef, () =>
  {
    console.log("overlay resize!");
    onParentResize();
  })

  onParentResize();

  if (props.isDraggable)
  {
    handleDraggable();
  }

  if (props.isResizable)
  {
    handleResizable();
  }
})

const handleDraggable = () =>
{
  Draggable.create(drElement.value, {
    type: "left,top",
    trigger: draggablePortionsContainer.value.children,
    edgeResistance: 1,
    bounds: props.parentContainerRef,
    onDragStart: () => {
      emits("onDragResizeStart");
    },
    onDragEnd: () => {
      emits("onDragResizeEnd");
    },
  });
}

const handleResizable = () =>
{
  initResizeBottomRight(bottomRightResizer);
  initResizeBottomRight(bottomLeftResizer);
  initResizeBottomRight(topRightResizer);
  initResizeBottomRight(topLeftResizer);
}

const minimum_size = 20;

let currentResizer: Ref,
    original_width: number,
    original_height: number,
    original_x: number,
    original_y: number,
    original_mouse_x: number,
    original_mouse_y: number;

const initResizeBottomRight = (resizeHandler: Ref) =>
{
  resizeHandler.value.addEventListener('mousedown', function(e: MouseEvent)
  {
    e.preventDefault()

    emits("onDragResizeStart");

    currentResizer = resizeHandler;

    const parentRect = props.parentContainerRef.getBoundingClientRect();

    original_width = parseFloat(getComputedStyle(drElement.value, null).getPropertyValue('width').replace('px', ''));
    original_height = parseFloat(getComputedStyle(drElement.value, null).getPropertyValue('height').replace('px', ''));
    original_x = drElement.value.getBoundingClientRect().left - parentRect.left;
    original_y = drElement.value.getBoundingClientRect().top - parentRect.top;
    original_mouse_x = e.pageX;
    original_mouse_y = e.pageY;

    window.addEventListener('mousemove', resize)
    window.addEventListener('mouseup', stopResize)
  })
}

const resize = (e: MouseEvent) =>
{
  const parentRect = props.parentContainerRef.getBoundingClientRect();
  const drRect = drElement.value.getBoundingClientRect();

  if (currentResizer.value.classList.contains('bottom-right-resizer')) {
    let width = original_width + (e.pageX - original_mouse_x);
    let height = original_height + (e.pageY - original_mouse_y)

    if (drRect.left + width >= parentRect.left + parentRect.width)
      width = parentRect.left + parentRect.width - drRect.left;

    if (width > minimum_size) {
      drElement.value.style.width = width + 'px'
    }

    if (drRect.top + height >= parentRect.top + parentRect.height)
      height = parentRect.top + parentRect.height - drRect.top;

    if (height > minimum_size) {
      drElement.value.style.height = height + 'px'
    }
  }
  else if (currentResizer.value.classList.contains('bottom-left-resizer')) {
    let height = original_height + (e.pageY - original_mouse_y)
    let width = original_width - (e.pageX - original_mouse_x)
    let left = original_x + (e.pageX - original_mouse_x)

    if (drRect.top + height >= parentRect.top + parentRect.height)
      height = parentRect.top + parentRect.height - drRect.top;

    if (height > minimum_size) {
      drElement.value.style.height = height + 'px'
    }

    if (left <= 0) {
      left = 0;
      width = drRect.right - parentRect.left;
    }

    if (width > minimum_size) {
      drElement.value.style.width = width + 'px'
      drElement.value.style.left = left + 'px'
    }
  }
  else if (currentResizer.value.classList.contains('top-right-resizer')) {
    let width = original_width + (e.pageX - original_mouse_x)
    let height = original_height - (e.pageY - original_mouse_y)
    let top = original_y + (e.pageY - original_mouse_y);

    if (drRect.left + width >= parentRect.left + parentRect.width)
      width = parentRect.left + parentRect.width - drRect.left;

    if (width > minimum_size) {
      drElement.value.style.width = width + 'px'
    }

    if (top <= 0) {
      top = 0;
      height = drRect.bottom - parentRect.top;
    }

    if (height > minimum_size) {
      drElement.value.style.height = height + 'px'
      drElement.value.style.top = top + 'px'
    }
  }
  else {
    let width = original_width - (e.pageX - original_mouse_x)
    let height = original_height - (e.pageY - original_mouse_y)
    let left = original_x + (e.pageX - original_mouse_x);
    let top = original_y + (e.pageY - original_mouse_y);

    if (left <= 0) {
      left = 0;
      width = drRect.right - parentRect.left;
    }

    if (width > minimum_size) {
      drElement.value.style.width = width + 'px'
      drElement.value.style.left = left + 'px'
    }

    if (top <= 0) {
      top = 0;
      height = drRect.bottom - parentRect.top;
    }

    if (height > minimum_size) {
      drElement.value.style.height = height + 'px'
      drElement.value.style.top = top + 'px'
    }
  }
}

const stopResize = () => {
  window.removeEventListener('mousemove', resize)
  emits("onDragResizeEnd");
}

onUnmounted(() => {
  // removes the event just in case they were still running
  stopResize();
})

// ------------------------------
//  On parent resize, adjust the element's dimensions
// ------------------------------

const onParentResize = () =>
{
  if (drElement.value)
  {
    drElement.value.style.left = props.startLeftPosition + "%";
    drElement.value.style.top = props.startTopPosition + "%";
    drElement.value.style.width = props.startWidth + "%";
    drElement.value.style.height = props.startHeight + "%";
  }
}

// ------------------------------
//  Click in the middle
// ------------------------------

const onClick = (e: MouseEvent) => {
  if (!e.ctrlKey)
    emits("onClick");
}

const onClickInTheMiddle = (e: MouseEvent) => {
  if (!e.ctrlKey)
    emits("onClickInTheMiddle");
}

// ------------------------------
//  Ref exposition
// ------------------------------

const drElementMiddle = ref();

expose({
  drElement,
  drElementMiddle
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('dr-element ' + __props.className),
    ref_key: "drElement",
    ref: drElement,
    onMousedown: _withModifiers(onClick, ["stop"])
  }, [
    (__props.isDraggableOnlyFromBorders)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dr-element-inside",
          ref_key: "drElementInside",
          ref: drElementInside
        }, [
          _createElementVNode("div", {
            class: "dr-element-middle",
            ref_key: "drElementMiddle",
            ref: drElementMiddle,
            onMousedown: onClickInTheMiddle
          }, null, 544),
          _withDirectives(_createElementVNode("div", {
            class: "draggable-portions",
            ref_key: "draggablePortionsContainer",
            ref: draggablePortionsContainer
          }, _hoisted_6, 512), [
            [_vShow, !__props.isDisabled]
          ]),
          (__props.isResizable)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "resizer bottom-right-resizer",
                ref_key: "bottomRightResizer",
                ref: bottomRightResizer
              }, null, 512)), [
                [_vShow, !__props.isDisabled]
              ])
            : _createCommentVNode("", true),
          (__props.isResizable)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "resizer bottom-left-resizer",
                ref_key: "bottomLeftResizer",
                ref: bottomLeftResizer
              }, null, 512)), [
                [_vShow, !__props.isDisabled]
              ])
            : _createCommentVNode("", true),
          (__props.isResizable)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "resizer top-left-resizer",
                ref_key: "topLeftResizer",
                ref: topLeftResizer
              }, null, 512)), [
                [_vShow, !__props.isDisabled]
              ])
            : _createCommentVNode("", true),
          (__props.isResizable)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "resizer top-right-resizer",
                ref_key: "topRightResizer",
                ref: topRightResizer
              }, null, 512)), [
                [_vShow, !__props.isDisabled]
              ])
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ], 512))
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}
}

})